// ============================================================
//  Qbrix Cart Page — qbrix-cart.js
//  Depends on: qbrix-theme.js (loaded before, provides brickSrc etc.)
//  Functions: cloneCartTicker, initCartQty, utmPromoAutofill,
//             handlePromoApply, handleCheckout, initSectionAnimations
// ============================================================

// ─── Ticker Clone ──────────────────────────────────────────
function cloneCartTicker() {
  var track = document.getElementById('cart-ticker-track');
  if (!track) return;
  var group = track.querySelector('.cart-ticker-group');
  if (group && !track.dataset.cloned) {
    track.appendChild(group.cloneNode(true));
    track.appendChild(group.cloneNode(true));
    track.dataset.cloned = 'true';
  }
}

// ─── AJAX Qty / Remove ─────────────────────────────────────
function initCartQty() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.cart-qty-btn');
    if (!btn) return;

    var action = btn.dataset.action;
    var line = parseInt(btn.dataset.line, 10);
    var qtyEl = document.getElementById('qty-line-' + line);
    if (!qtyEl) return;

    var current = parseInt(qtyEl.textContent, 10) || 1;
    var newQty = action === 'plus' ? current + 1 : Math.max(0, current - 1);

    cartAjaxChange(line, newQty, function(cart) {
      if (newQty === 0) {
        var itemEl = document.querySelector('[data-line="' + line + '"]');
        if (itemEl) {
          itemEl.classList.add('removing');
          setTimeout(function() { itemEl.remove(); checkEmptyState(cart); }, 380);
        }
      } else {
        qtyEl.textContent = newQty;
        updateSummaryLine(line, newQty, cart);
      }
      updateCartTotal(cart);
      updateCartCount(cart);
    });
  });

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.cart-item-remove');
    if (!btn) return;
    var line = parseInt(btn.dataset.line, 10);
    cartAjaxChange(line, 0, function(cart) {
      var itemEl = document.querySelector('[data-line="' + line + '"]');
      if (itemEl) {
        itemEl.classList.add('removing');
        setTimeout(function() { itemEl.remove(); checkEmptyState(cart); }, 380);
      }
      updateCartTotal(cart);
      updateCartCount(cart);
    });
  });
}

// POST /cart/change.js (Shopify AJAX API)
function cartAjaxChange(line, quantity, callback) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: line, quantity: quantity })
  })
  .then(function(r) { return r.json(); })
  .then(function(cart) { if (typeof callback === 'function') callback(cart); })
  .catch(function(err) { console.error('Cart change error:', err); });
}

function updateSummaryLine(line, qty, cart) {
  var item = cart.items[line - 1];
  if (!item) return;
  var sumQtyEl = document.getElementById('summary-qty-' + line);
  var sumPriceEl = document.getElementById('summary-price-' + line);
  var itemPriceEl = document.querySelector('[data-line="' + line + '"] .cart-item-price');
  if (sumQtyEl) sumQtyEl.textContent = qty;
  if (sumPriceEl) {
    sumPriceEl.textContent = formatMoney(item.original_line_price);
    sumPriceEl.dataset.originalPrice = item.original_line_price;
  }
  if (itemPriceEl) {
    itemPriceEl.dataset.originalPrice = item.original_line_price;
    itemPriceEl.dataset.finalPrice = item.final_line_price;
    if (item.original_line_price !== item.final_line_price) {
      itemPriceEl.innerHTML =
        '<span class="cart-item-price-original">' + formatMoney(item.original_line_price) + '</span>' +
        '<span class="cart-item-price-discounted">' + formatMoney(item.final_line_price) + '</span>';
    } else {
      itemPriceEl.textContent = formatMoney(item.original_line_price);
    }
  }
}

function updateCartTotal(cart) {
  var totalEl = document.getElementById('cart-total');
  if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
}

function updateCartCount(cart) {
  var badge = document.getElementById('cart-count-badge');
  if (badge) badge.textContent = cart.item_count + ' item';
  // Обновить header cart count если нужно
  var headerBadge = document.getElementById('cart-count');
  if (headerBadge) headerBadge.textContent = cart.item_count;
}

function checkEmptyState(cart) {
  if (cart.item_count === 0) {
    var hasItems = document.getElementById('cart-has-items');
    var emptyState = document.getElementById('cart-empty-state');
    if (hasItems) hasItems.style.display = 'none';
    if (emptyState) emptyState.style.display = 'flex';
  }
}

// Shopify prices are in cents
function formatMoney(cents) {
  var amount = cents / 100;
  return 'Rp ' + amount.toLocaleString('id-ID');
}

// ─── UTM Promo Autofill ─────────────────────────────────────
// Задел на task-12: task-12 будет писать куку utm_promo
// Когда кука появится — поле заполнится автоматически
function utmPromoAutofill() {
  var input = document.getElementById('cart-promo-input');
  if (!input) return;
  var lsCode = '';
  try { lsCode = localStorage.getItem('qbrix_promo_code') || ''; } catch(e) {}
  var val = getCookie('utm_promo') || getURLParam('discount') || lsCode;
  if (val) {
    input.value = val.toUpperCase();
    return true;  // сигнал — есть код для автоприменения
  }
  return false;
}

function getCookie(name) {
  return ('; ' + document.cookie).split('; ' + name + '=').pop().split(';').shift() || '';
}

function getURLParam(name) {
  return new URLSearchParams(window.location.search).get(name) || '';
}

// ─── Render Item Prices ─────────────────────────────────────
function renderItemPrices(discount, preDiscountTotal) {
  document.querySelectorAll('.cart-item-price').forEach(function(el) {
    var originalCents = parseInt(el.dataset.originalPrice || '0', 10);
    if (!originalCents) return;
    if (discount > 0 && preDiscountTotal > 0) {
      var itemDiscountedCents = Math.round(originalCents * (1 - discount / preDiscountTotal));
      el.innerHTML =
        '<span class="cart-item-price-original">' + formatMoney(originalCents) + '</span>' +
        '<span class="cart-item-price-discounted">' + formatMoney(itemDiscountedCents) + '</span>';
    } else {
      el.textContent = formatMoney(originalCents);
    }
  });
}

// ─── Promo Apply ───────────────────────────────────────────
var _promoApplyInFlight = false;  // guard against concurrent submissions

function handlePromoApply() {
  if (_promoApplyInFlight) return;  // prevent race via rapid Enter + click
  var input = document.getElementById('cart-promo-input');
  var btnEl = document.querySelector('.cart-promo-btn');
  var successEl = document.getElementById('promo-success');
  var errorEl = document.getElementById('promo-error');
  var totalEl = document.getElementById('cart-total');
  if (!input) return;

  var code = input.value.trim().toUpperCase();
  if (successEl) successEl.style.display = 'none';
  if (errorEl) errorEl.style.display = 'none';

  if (!code) {
    if (errorEl) { errorEl.textContent = 'Masukkan kode promo terlebih dahulu.'; errorEl.style.display = 'block'; }
    return;
  }

  // Disable button during request
  _promoApplyInFlight = true;
  if (btnEl) { btnEl.disabled = true; btnEl.textContent = '...'; }

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ discount: code })
  })
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    var found = cart.discount_codes && cart.discount_codes.find(function(d) {
      return d.code.toUpperCase() === code;
    });
    if (!found || found.applicable === false) {
      if (errorEl) { errorEl.textContent = 'Kode promo tidak valid.'; errorEl.style.display = 'block'; }
      input.style.borderColor = '';
      return;
    }
    // Успех
    input.style.borderColor = 'rgba(34,197,94,0.5)';
    if (successEl) successEl.style.display = 'block';

    // Show subtotal breakdown
    var breakdown = document.getElementById('promo-breakdown');
    var subtotalEl = document.getElementById('promo-subtotal-val');
    var promoDiscountVal = document.getElementById('promo-discount-val');
    var discountAmount = cart.total_discount || 0;
    if (breakdown) {
      if (discountAmount > 0) {
        if (subtotalEl) subtotalEl.textContent = formatMoney((cart.items_subtotal_price || 0) + (cart.total_discount || 0));
        if (promoDiscountVal) promoDiscountVal.textContent = '−' + formatMoney(discountAmount);
        breakdown.style.display = 'block';
      }
    }

    // Обновить TOTAL
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    // Показать pill
    showPromoCode(code);
    var preDiscountTotal = (cart.items_subtotal_price || 0) + (cart.total_discount || 0);
    renderItemPrices(cart.total_discount || 0, preDiscountTotal);
  })
  .catch(function() {
    if (errorEl) { errorEl.textContent = 'Terjadi kesalahan. Coba lagi.'; errorEl.style.display = 'block'; }
  })
  .finally(function() {
    _promoApplyInFlight = false;
    if (btnEl) { btnEl.disabled = false; btnEl.textContent = 'Terapkan'; }
  });
}

function showPromoCode(code) {
  var wrap = document.getElementById('promo-pill-wrap');
  if (!wrap) return;
  // Build pill via DOM API — avoids XSS from unsanitized code string
  wrap.innerHTML = '';
  var pill = document.createElement('span');
  pill.className = 'promo-pill';
  var codeSpan = document.createElement('span');
  codeSpan.className = 'promo-pill-code';
  codeSpan.textContent = code;  // textContent is safe — no HTML parsing
  var removeBtn = document.createElement('button');
  removeBtn.type = 'button';
  removeBtn.className = 'promo-pill-remove';
  removeBtn.setAttribute('aria-label', 'Hapus kode promo');
  removeBtn.textContent = '×';
  removeBtn.addEventListener('click', function() { removePromoCode(removeBtn); });
  pill.appendChild(codeSpan);
  pill.appendChild(removeBtn);
  wrap.appendChild(pill);
  wrap.style.display = 'block';
  // Скрыть поле ввода и кнопку Terapkan
  var row = document.querySelector('.cart-promo-row');
  if (row) row.style.display = 'none';
}

function removePromoCode(btn) {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ discount: '' })
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    window.location.reload();
  })
  .catch(function() {
    var wrap = document.getElementById('promo-pill-wrap');
    var row = document.querySelector('.cart-promo-row');
    var successEl = document.getElementById('promo-success');
    if (wrap) { wrap.innerHTML = ''; wrap.style.display = 'none'; }
    if (row) row.style.display = 'flex';
    if (successEl) successEl.style.display = 'none';
  });
}

// ─── Promo State Restore ────────────────────────────────────
function initPromoState(callback) {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var active = cart.discount_codes && cart.discount_codes.find(function(d) { return d.applicable; });
      if (!active) {
        if (typeof callback === 'function') callback(false);
        return;
      }

      var code = active.code;
      var discountAmount = cart.total_discount || 0;

      showPromoCode(code);

      if (discountAmount > 0) {
        var breakdown = document.getElementById('promo-breakdown');
        var subtotalEl = document.getElementById('promo-subtotal-val');
        var discountEl = document.getElementById('promo-discount-val');
        if (breakdown) {
          if (subtotalEl) subtotalEl.textContent = formatMoney((cart.items_subtotal_price || 0) + (cart.total_discount || 0));
          if (discountEl) discountEl.textContent = '−' + formatMoney(discountAmount);
          breakdown.style.display = 'block';
        }
        var preDiscountTotal = (cart.items_subtotal_price || 0) + (cart.total_discount || 0);
        renderItemPrices(cart.total_discount || 0, preDiscountTotal);
      }

      if (typeof callback === 'function') callback(true);
    })
    .catch(function() {
      if (typeof callback === 'function') callback(false);
    });
}

// ─── Checkout ──────────────────────────────────────────────
// Если кode promo введён — добавляем ?discount=CODE к /checkout URL
function handleCheckout(e) {
  var input = document.getElementById('cart-promo-input');
  var inputCode = input ? input.value.trim() : '';
  var lsCode = '';
  try { lsCode = localStorage.getItem('qbrix_promo_code') || ''; } catch(ex) {}
  var code = inputCode || lsCode;
  if (code) {
    window.location.href = '/checkout?discount=' + encodeURIComponent(code.toUpperCase());
  } else {
    window.location.href = '/checkout';
  }
  return false;
}

// ─── Section Animate ───────────────────────────────────────
function initSectionAnimations() {
  var els = document.querySelectorAll('.section-animate');
  if (!('IntersectionObserver' in window)) {
    els.forEach(function(el) { el.classList.add('in-view'); });
    return;
  }
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08 });
  els.forEach(function(el) { observer.observe(el); });
}

// ─── Promo Enter key ───────────────────────────────────────
function initPromoKeydown() {
  var input = document.getElementById('cart-promo-input');
  if (input) {
    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') { e.preventDefault(); handlePromoApply(); }
    });
  }
}

// ─── Cart Breadcrumbs ──────────────────────────────────────
function initCartBreadcrumbs() {
  var nav = document.querySelector('.breadcrumbs-wrap');
  if (!nav) return;
  requestAnimationFrame(function() {
    nav.classList.add('crumbs-played');
  });
}

// ─── Init ──────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function() {
  cloneCartTicker();
  initCartQty();
  var hasAutoCode = utmPromoAutofill();
  // initPromoState читает cart.js — если Shopify уже знает дискаунт, восстанавливаем UI.
  // Если нет (новая сессия, код только в localStorage) — применяем автоматически.
  initPromoState(function(alreadyActive) {
    if (!alreadyActive && hasAutoCode) {
      handlePromoApply();
    }
  });
  initSectionAnimations();
  initPromoKeydown();
  initCartBreadcrumbs();
});
